import {combineReducers} from "@reduxjs/toolkit";
import { connectRouter } from 'connected-react-router'
import {historyObject} from "historyObject";
import account from "features/pages/account/reducer";
import auth from "store/reducer/auth/reducer";
import user from "store/reducer/user";
import company from "store/reducer/company/reducer";
import modals from "features/modals/reducer";
import profile from "features/pages/profile/reducer";
import static_data from "store/reducer/static/reducer";
import home from "features/pages/home/reducer";
import video from "store/reducer/video";
import comments from "store/reducer/comments";
import directory from "./directory";
import payments from "./payments";
import suggested from "features/components/suggested/reducer";
import search from "features/modals/search/reducer";
import event from "store/reducer/event";
import publicProfile from "features/pages/profile-public/reducer";
import notifications from "./notifications";
import threads from "./threads";
import faq from "features/pages/help/reducer";
import people from "./people";
import private_profile from "features/pages/single-people/reducer";
import skills from "./skills";
import recommendation from "./recommendation";
import message from "./message";

export default combineReducers({
    router: connectRouter(historyObject),
    account,
    auth,
    user,
    company,
    modals,
    profile,
    static_data,
    home,
    video,
    comments,
    directory,
    payments,
    suggested,
    search,
    event,
    public: publicProfile,
    notifications,
    threads,
    faq,
    people,
    private_profile,
    skills,
    recommendation,
    message
});

